import type { IPageSeoInfo } from '~/composables/usePageSeoInfo';

export const formatCanonicalUrl = (
  rawCanonical: string | undefined,
  currentPath: string,
  seoInfo: IPageSeoInfo | null,
  baseUrl: string
): string => {
  const cleanBaseUrl = baseUrl.replace(/\/$/, '');

  let pathPart = '';
  if (rawCanonical) {
    pathPart = rawCanonical.replace(cleanBaseUrl, '');
  } else {
    pathPart = currentPath.split('?')[0];
  }

  const isMsRoute = currentPath.startsWith('/ms-my') || currentPath.startsWith('ms-my');

  // Strip leading /ms-my or ms-my from pathPart
  let cleanPathPart = pathPart;
  if (cleanPathPart.startsWith('/ms-my')) {
    cleanPathPart = cleanPathPart.replace(/^\/ms-my/, '');
  } else if (cleanPathPart.startsWith('ms-my')) {
    cleanPathPart = cleanPathPart.replace(/^ms-my/, '');
  }

  if (!cleanPathPart.startsWith('/')) {
    cleanPathPart = '/' + cleanPathPart;
  }

  const enUrl = `${cleanBaseUrl}${cleanPathPart}`;
  const msUrl = `${cleanBaseUrl}/ms-my${cleanPathPart}`;

  // If not 'seo-webpage', canonical is ALWAYS 'en'
  if (!seoInfo || seoInfo.pageTemplate !== 'seo-webpage') {
    return enUrl;
  }

  const langs = seoInfo.availableLangs || ['en'];
  const hasEn = langs.includes('en');
  const hasMs = langs.includes('ms-my');

  if (hasEn && hasMs) {
    return isMsRoute ? msUrl : enUrl;
  } else if (hasMs && !hasEn) {
    return msUrl;
  } else {
    return enUrl;
  }
};